import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLightning"><Path d="M8.28125 2L2.53125 13.5H7.897L5.35722 22.3719L23.3274 7.5H16.4583L19.2083 2H8.28125Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightning;
